import React from "react";
export var usePlaylistDuration = function (tracks) {
    return React.useMemo(function () {
        if (!tracks)
            return "";
        var seconds = tracks.reduce(function (acc, entry) { return acc + entry.duration.seconds; }, 0);
        var time = new Date(0, 0, 0);
        time.setSeconds(seconds);
        return time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
    }, [tracks]);
};
